module.exports = fox._r("images/press/icon-title-blog.png", __webpack_public_path__ + "_/common/images/press/icon-title-blog.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/press/icon-title-blog.png
// module id = 374
// module chunks = 2